//Reference: EN051 (Modified) 

/*  
    Added a new field 'ID_QUESTIONS' which doesn't belong to the original EN051.
    The reason is to replicate an optimized backend that will return this field whose value will 
    contain an array of objects from EN052. This relationship EN051 & EN052 belongs to EN053.
*/

import { Mappeable } from './mappeable.model';
import { Question } from './question.model';
import * as _ from 'lodash';

export class Survey extends Mappeable {
    idQuestionnairePk: number;
    //CODE: string;
    txtTitle: string;
    txtDescription: string;
    //NUM_VERSION: string;
    dateVersion: string;
    mrkActive: boolean;
    //DATE_INSERT: string;
    //DATE_UPDATE: string;
    //USER_INSERT: string;
    //USER_UPDATE: string;
    //ID_QUESTIONS: Question[];

    constructor(o) {
        super(o);
        this.mrkActive = _.isUndefined(this.mrkActive) || _.isNull(this.mrkActive) ? false : this.mrkActive;
    }

    public mapToBack() {
        return {
            txtTitle: this.txtTitle,
            txtDescription: this.txtDescription,
            mrkActive: this.mrkActive
        }
    }
}
